import { render, staticRenderFns } from "./turn_page.vue?vue&type=template&id=c5bad1e6&scoped=true&"
import script from "./turn_page.vue?vue&type=script&lang=js&"
export * from "./turn_page.vue?vue&type=script&lang=js&"
import style0 from "./turn_page.vue?vue&type=style&index=0&id=c5bad1e6&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bad1e6",
  null
  
)

export default component.exports